<template>
<h1 class="mb-3">Vestigingsadressen</h1>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
<div class="list-group list-group-flush">
  <div class="list-group-item TumiTitle">
    <div class="align-items-start text-start row">
      <div class="col-4">
        <b>Adres</b>
      </div>
      <div class="col-2">
        <b>Dorpskern</b>
      </div>          
      <div class="col-2">
        <b>Zone</b>
      </div>
      <div class="col-2">
        <b>Aanvang</b>
      </div>        
      <div class="col-2">
        <b>Einde</b>
      </div>                
    </div>
  </div>
  <div v-for="item in adressen" :key="item.vestigingsadresseN_ID" @click="clickAdresses(item.vestigingsadresseN_ID)" class="list-group-item TumiClickable">
    <div class="align-items-center text-start row">
      <div class="col-4">
        {{item.vestigingsadresseN_STRAATTINUMMERTBUS}}
        {{item.vestigingsadresseN_POSTCODE}}
        {{item.vestigingsadresseN_GEMEENTE}}
      </div>
      <div class="col-2">
        {{item.vestigingsadresseN_DORPSKERN}}
      </div>          
      <div class="col-2">
        {{item.zoneS_ZONE}}
      </div>
      <div class="col-2">
        {{item.vestigingsadresseN_AANVANG}}
      </div>        
      <div class="col-2">
        {{item.vestigingsadresseN_EINDE}}
      </div>                
    </div>
  </div>
</div>

<button @click="openCloseNouveau" class="btn btn-secondary float-end mt-3">+</button>
<div class="clearfix"></div>
<NewAdress class="mt-3" v-if="openNouveau" @ajout="AjouterAdresse"/>
<DynamicPage class="mt-3" v-if="activeObject" :objet="activeObject" :validate="validationError" @action="Act"/>
<BedrijfsRuimtes class="mt-3" v-if="adrId" :id="adrId"/>
</template>
   
<script>
import NewAdress from './NewAdress.vue'
import DynamicPage from './DynamicPage.vue'
import BedrijfsRuimtes from './BedrijfsRuimtes.vue'

export default {
  name: 'TableAdressen',
  props:{
    id: null
  },
  components:{
    NewAdress,
    DynamicPage,
    BedrijfsRuimtes
  },
  data:function(){
    return{
      openNouveau:false,
      path:{
          name:"Vestigingsadressen", 
          path: "/portaal/GetVestigingsAdressen?id=", 
          pathSet: "/portaal/SetVestigingsAdressen",
          validation: function(obj){
            if(obj != null)
              return null;
          }
      },
      activeObject: null,
      validationError: null,
      adrId: null
    }
  },
  computed:{
    adressen(){
      return this.$store.state.dynamicStore[this.path.path + this.id];
    }
  },
  methods:{
    async Act(retour){
      //ERREUR BLANCO
      this.validationError = null;

      //CHECK VALIDATION OF VIEW
      const res = this.path.validation(retour);
      
      //IF NOT VALIDATED SHOW ERROR
      if(res != null)
      {
        this.validationError = res;
        return;
      }

      //ELSE UPDATE DATABASE
      const pathSet = this.path.pathSet;
      await this.$store.dispatch('dynamicStore/setDynamic', {pathSet, retour});
    },
    clickAdresses(idAdresses){
      //IF WE'RE IN THE SAME ACTIVE OBJECT THAN THE ONE SELECTED AND THE NEW TAB ISN'T OPEN WE DEACTIVE THE OBJECT
      if(this.activeObject != null && this.activeObject.vestigingsadresseN_ID == idAdresses && !this.openNouveau)
      {
        this.activeObject = null;
        this.adrId = null;
        return;
      }

      //IF CREATE OPEN, WE CLOSE IT
      if(this.openNouveau)
        this.openCloseNouveau();

      //GET THE ADRESS SELECTED
      const adresseCible = this.adressen.find(i=>i.vestigingsadresseN_ID == idAdresses);

      //PASS IT TO THE DYNAMIC VIEW
      this.activeObject = adresseCible;
      this.adrId = this.activeObject.vestigingsadresseN_ID;
    },   
    openCloseNouveau(){
      this.activeObject = null;

      if(this.openNouveau)
      {
        this.$store.dispatch('dynamicStore/deleteSolidState','adres');
        this.openNouveau = false; 
      }
      else
        this.openNouveau = true;

    },
    async AjouterAdresse(id){
      const retour = {"orgId" : this.id, "adrId" : id} 
      const pathSet = "/portaal/SetAdres"
      await this.$store.dispatch('dynamicStore/setDynamic', {pathSet, retour});
      this.openCloseNouveau();
      this.refresh()    
    },
    async refresh(){
      const path = this.path.path + this.id;
      await this.$store.dispatch('dynamicStore/getDynamic', path);
    }
  },
  async created(){
    await this.refresh();
  }
}
</script>   

<style>
  .TumiClickable{
    cursor: pointer;
  }

  .TumiClickable:hover{
    background-color: rgb(213, 211, 211);
  }

  .TumiTitle{
    background-color: rgb(221, 232, 247) !important;
  }

  b{
    font-weight: 900 !important;
    color:black;
  }
</style>